import { useQuery } from '@tanstack/react-query';

import { api } from '@shared/api/client';
import { key, STALE_TIME } from '@shared/api/query-keys';

import type { PageSlug } from './constants';
import type { InformationalPage } from './types';

/**
 * One read per page, keyed exactly as the mutation invalidates it —
 * `['content', 'informationalPage', <slug>]`, the tuple PRD-TDD §10.2 declares.
 *
 * `staleTime` is the detail default of **0**: an operator arriving from the
 * other entry of the strip has just written the sibling page, and a body held
 * behind a stale window would show them yesterday's text on a surface whose
 * whole job is to be current.
 */
export function informationalPageKey(slug: PageSlug) {
  return key('content', 'informationalPage', slug);
}

export function useInformationalPage(slug: PageSlug) {
  return useQuery({
    queryKey: informationalPageKey(slug),
    queryFn: () => api.get<InformationalPage>('content', `/admin/informationalPages/${slug}`),
    staleTime: STALE_TIME.detail,
  });
}
